<template>
  <v-menu
    absolute
    offset-y
    min-width="250"
  >
    <!-- pass thru activator slot -->
    <template #activator="slotData">
      <slot
        name="activator"
        v-bind="slotData"
      />
    </template>

    <!-- Status List -->
    <v-list>
      <v-list-item-group
        v-model="selected"
        active-class="primary--text"
      >
        <template v-for="(item, i) in statuses">
          <v-divider
            v-if="item.divider === true"
            :key="i"
          />
          <v-list-item
            v-else
            :key="i"
            :value="item.value"
            @click="itemClicked(item.value)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
              <v-list-item-subtitle v-if="isCheckedOutStatus(item.value)">
                {{ endDateTextForCheckedOut }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-avatar>
              <v-icon
                small
                class="mt-1"
                :color="colorForStatus(item.value)"
              >
                mdi-circle
              </v-icon>
            </v-list-item-avatar>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script lang='ts'>
import Vue, { PropType } from 'vue';
import Reservation, { ReservationStatus, ReservationType } from '@/model/Reservation';
import { reservationStatusItems } from '@/util/status';
import { endDateForCheckedOut } from '@/services/reservation-utils';
import { colorForStatus } from '@/components/helpers/colors';

export default Vue.extend({
  name: 'StatusSelectionMenu',
  components: { },
  props: {
    value: { type: String, required: true },
    reservation: { type: Reservation, required: true },
  },
  data() {
    return {
      selected: this.value,
      statuses: reservationStatusItems(),
    };
  },
  computed: {
    endDateTextForCheckedOut(): string | null {
      const endDate = endDateForCheckedOut(this.reservation);
      const endDateText = this.$localized.hourMinText(endDate);
      if (!endDateText) return null;
      const text = this.$i18n.t('label.ending_time_will_be_x', [endDateText]).toString();
      return text;
    },
  },
  watch: {
    value() {
      this.selected = this.value;
    },
  },
  methods: {
    itemClicked(value: string) {
      this.$emit('item-clicked', value);
    },
    isCheckedOutStatus(s: ReservationStatus): boolean {
      return s === ReservationStatus.CheckedOut;
    },
    colorForStatus(s: ReservationStatus): string {
      return colorForStatus(s);
    },
  },
});
</script>
